<template>
  <section>
    <left-menu />

    <div id="mainContent" class="list-fit-content">

      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 pg-title">
          <h1 class="certa">Log de registros</h1>
        </div>

        <div class="col-xs-12 col-sm-12 col-md-12 offset-top-30">
          <div class="col-xs-12 col-sm-12 col-md-12 default-box box-list-fit">
            <div class="infos">
              <h2 class="certa">Lista de log</h2>
            </div>

            <div v-if="dataLogHistory.length" class="col-xs-12 col-sm-12 col-md-12 offset-top-20">
              <button type="button" v-on:click="sendData()" :disabled="loadingRequest" v-bind:class="{'disable': loadingRequest}" class="btn-search-fit">
                <div v-if="loadingRequest" class="loading-btn-login">
                  <div class="spinner-btn-login">
                    <div class="rect1"></div>
                    <div class="rect2"></div>
                    <div class="rect3"></div>
                    <div class="rect4"></div>
                    <div class="rect5"></div>
                  </div>
                </div>
                <span v-else>Enviar</span>
              </button>
            </div>

            <!-- Loading -->
            <div v-if="loading" class="loader-page-content">
              <div class="spinner">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </div>

            <div v-if="dataLogHistory.length" class="col-xs-12 col-sm-12 col-md-12 padding-null offset-top-30">
              <div class="table-responsive table-clean">
                <table class="table">
                  <thead>
                  <tr>
                    <th class="certa no-wrap">Data</th>
                    <th class="certa no-wrap">Página</th>
                    <th class="certa no-wrap">Browser</th>
                    <th class="certa no-wrap">Ação</th>
                    <th class="certa no-wrap">JSON</th>
                    <th class="certa no-wrap">Status</th>
                    <th class="certa no-wrap">Valor do erro</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="r in dataLogHistory">
                    <td>
                      <small>{{r.date | formatDateHours}}</small>
                    </td>
                    <td>
                      <small>{{r.route}}</small>
                    </td>
                    <td>
                        <small>{{browserInfo.name}} - {{browserInfo.version}}</small>
                    </td>
                    <td>
                      <small>{{r.onAction}}</small>
                    </td>
                    <td>
                      <small>{{r.dataAction}}</small>
                    </td>
                    <td>
                      <small v-bind:class="r.isError ? 'msg-invalid' : 'msg-valid'">{{r.isError ? 'Erro' : 'Sucesso'}}</small>
                    </td>
                    <td>
                      <small>{{r.reason}}</small>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div v-if="!loading && !dataLogHistory.length" class="col-xs-12 col-sm-12 col-md-12 box-empty offset-top-30">
              <img src="/src/assets/img/empty/solicitações.png" alt="Comunicado" class="img-fluid img-responsive" />
              <p class="nunito">Nenhum histórico de log encontrado.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <vue-footer/>
  </section>
</template>

<script>
  import leftMenu from '../../components/leftMenu.vue'
  import vueFooter from "../../components/footer";
  import { UTIL_SERVICE } from "../../../../utils";
  import {SEND_LOG_REPORT} from "../../../../urlConfig";
  import {REQUEST_SERVICE} from "../../../../requestConfig";
  import swal from "sweetalert";

  export default {
    name: 'log-history',
    components: {
      leftMenu,
      vueFooter,
    },
    data() {
      return {
        loading: false,
        loadingRequest: false,
        userInfo: {},
        dataLogHistory: [],
        browserInfo: UTIL_SERVICE.checkBrowser()
      }
    },
    methods: {
      sendData() {
        if (!this.loadingRequest) {
          this.loadingRequest = true;

          const objectSend = {
            companyId: this.userInfo.companyId,
            userId: this.userInfo.id,
            browser: '',
            version: '',
            plataform: 'WEB',
            actions: [],
          };

          this.dataLogHistory.map((value, index) => {
            objectSend.browser = this.browserInfo.name;
            objectSend.version = this.browserInfo.version;
            delete value.browser;

            try {
              value.dataAction = JSON.stringify(value.dataAction);
              value.reason = JSON.stringify(value.reason);
              objectSend.actions.push(value);
            } catch (e) {}

            if (this.dataLogHistory.length === index + 1) {

              UTIL_SERVICE.console("Data Send:", objectSend);
              REQUEST_SERVICE.post(SEND_LOG_REPORT, objectSend).then((response) => {
                UTIL_SERVICE.console("RESULT POINT_HISTORY:", response.data);

                window.localStorage.removeItem("logHistory");
                UTIL_SERVICE.historyLog(true);

                swal("Aviso", "Todos os logs foram enviado com sucesso.", "success");
                this.$router.push({path: '/'});

                this.loadingRequest = false;
              }).catch(reason => {
                this.failRequest = true;
                this.loadingRequest = false;
                // Show errors.
                reason.response.data.erros.map((value, index) => {
                  swal("Aviso", value.value, "error");
                });
              });
            }
          });
        }
      },
    },
    beforeMount(){
      this.userInfo = UTIL_SERVICE.getStorage('userInfo');
      const logHistory = UTIL_SERVICE.getStorage('logHistory');

      if (logHistory.listPages) {
        this.dataLogHistory = logHistory.listPages;
      }
    }
  }
</script>


<style lang="scss">
.btn-search-fit {
  background: var(--linkColor);
  color: #ffffff;
  width: 200px;
  float: right;
  border: none;
  border-radius: 4px;
  height: 41px;
  line-height: 40px;
  font-weight: bold;
  cursor: pointer;

  &:hover {
    background: var(--blueDark);
  }
}
.msg-invalid, .msg-valid {
  color: #ffffff;
  width: 60px;
  font-weight: bold;
  border-radius: 4px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  display: block;
}

.msg-valid {
  background: var(--greenColor);
}

.msg-invalid {
  background: var(--redColor);
}
  .box-list-fit {
    .result-list-table {
      background: #fff;
      box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08);
      padding: 40px 40px 20px 40px;
      -webkit-border-radius: 4px !important;
      -moz-border-radius: 4px !important;
      border-radius: 4px !important;
      margin-bottom: 80px;

      .content-title {
        font-size: 15px;
        font-weight: 600;
        color: #7b7878;
        border-bottom: 1px solid #7b7878;
        float: right;
        margin-bottom: 30px;
        margin-top: 0;
      }

      blockquote {
        padding: 0 20px;
        margin: 0 0 30px;
        border-left: 5px solid #7b7878;

        p {
          font-size: 15px;
          font-weight: 600;
          color: #7b7878;
          margin: 0 0 6px;
        }
      }

      .success-box-table {
        color: #FFFFFF;
        border: 0;
        padding: 5px 14px;
        border-radius: 4px !important;
        background-color: #00a651;
        font-weight: 600;
        position: relative;
        top: 7px;
      }

      .incorrect-box-table {
        color: #FFFFFF;
        border: 0;
        padding: 5px 18px;
        font-weight: 600;
        border-radius: 4px !important;
        background-color: #e74a4e;
        position: relative;
        top: 7px;
      }
      table {
        .checkbox {
          text-align: center;
        }

        .link {
          color: #3598dc;
          top: 0;
          border-bottom: 1px solid #3598dc;
          cursor: pointer;

          &:hover, &:focus, &:active {
            font-weight: normal;
            text-decoration: none;
            color: #0F77AE;
            border-bottom: 1px dashed #0F77AE;
          }
        }

        thead {
          tr {
            th {
              i {
                margin-left: 5px;
              }
            }
          }
        }

        tbody {
          td {
            ul {
              display: block;
              margin: 0;
              padding: 0;

              li {
                display: inline-block;
                vertical-align: top;
                list-style: none;
                }
            }
          }
        }
      }

      h2 {
        color: #3598dc;
        font-size: 20px;
        margin-bottom: 40px;
        font-weight: 400;
        letter-spacing: 1px;
        border-bottom: 1px solid #3598dc;
        padding-bottom: 13px;
        margin-top: 0;
      }
    }

    .content-empty {
      min-height: 300px;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;

      p {
        font-size: 20px;
        text-transform: uppercase;
        text-align: center;
        font-weight: 600;
        letter-spacing: 1px;
      }
    }
  }

  .autocomplete-input {
    width: 80%;
    height: 37px;
    padding: 6px 12px;
    background-color: #fff;
    border: 1px solid #c2cad8;
    border-radius: 4px;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;

    @media screen and (max-width: 414px){
      width: 100%;
    }
  }

  .transition, .autocomplete, .showAll-transition, .autocomplete ul, .autocomplete ul li a{
    transition:all 0.3s ease-out;
    -moz-transition:all 0.3s ease-out;
    -webkit-transition:all 0.3s ease-out;
    -o-transition:all 0.3s ease-out;
  }

  .autocomplete ul{
    z-index: 1;
    font-family: "Montserrat", sans-serif;
    position: absolute;
    list-style: none;
    background: #d8d8d8;
    padding: 10px 0;
    display: inline-block;
    min-width: 15%;
    margin: 10px 0 0;
    width: 90%;
  }

  .autocomplete ul:before{
    content: "";
    display: block;
    position: absolute;
    height: 0;
    width: 0;
    border: 10px solid transparent;
    border-bottom: 10px solid #d8d8d8;
    left: 46%;
    top: -20px
  }

  .autocomplete ul li a{
    text-decoration: none;
    display: block;
    background: #d8d8d8;
    color: #2b2b2b;
    padding: 10px 5px 5px 10px;

    b {
      font-weight: 600;
      letter-spacing: 1px;
    }
  }

  .autocomplete ul li a:hover, .autocomplete ul li.focus-list a{
    color: #ffffff;
    background: #0f77ae;
  }

  .autocomplete ul li a span, /*backwards compat*/
  .autocomplete ul li a .autocomplete-anchor-label{
    display: block;
    margin-top: 3px;
    color: grey;
    font-size: 13px;
  }

  .autocomplete ul li a:hover .autocomplete-anchor-label,
  .autocomplete ul li.focus-list a span, /*backwards compat*/
  .autocomplete ul li a:hover .autocomplete-anchor-label,
  .autocomplete ul li.focus-list a span{ /*backwards compat*/
    color: white;
  }
  .remove-user2 {
    position: absolute;
    top: 32px;
    right: 73px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/vue/views/restricted/logHistory/logHistory.vue